export default __webpack_public_path__ + "static/media/55.5d5ebaf1.svg";